import { render, staticRenderFns } from "./WeeklyCommitmentPlanner.vue?vue&type=template&id=3b08e456&scoped=true&"
import script from "./WeeklyCommitmentPlanner.vue?vue&type=script&lang=js&"
export * from "./WeeklyCommitmentPlanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b08e456",
  null
  
)

export default component.exports